import styled from 'styled-components';
import Parent from '../style';

const PolicyWrapper = styled(Parent.PolicyWrapper)`
${({ theme }) => `
.viewSample {
    display: block;
    cursor:pointer;
    color: ${theme.colors.SECONDARY_MAIN};
    font-size: 14px;
    &:hover {
        text-decoration: underline;
    }
}
.sampleIcon {
    display: none;
}
`}
`;
const SelectedPolicy = styled(Parent.SelectedPolicy)`
flex: 0 0 25%;
padding-top: 0;
.viewMore {
    align-self: center;
    padding-left: 14px;
}
.MuiAvatar-root {
    width: 44px !important;
    height: 44px !important;
}
.subFormsection {
    padding-top: 3px;
    padding-left: 37px;
}
.subFields {
    display: flex;
    flex-direction: column;
    label {
     padding-bottom: 0;
     font-size: 14px;
    }
    .MuiInputBase-root.MuiInput-root {
        // height: 28px;
        
    }
    .MuiInputBase-root {
        width: 200px;
    }
}
.normalCheckbox {
    width: 220px;
    .Checkbox { 
        top: 2px;
    }
    rect.square {
        opacity: 1 !important;
    }
    span {
        padding-left: 10px;
        font-size: 20px;
    }
}
`;
const Styled = { SelectedPolicy , PolicyWrapper };
export default Styled;
